import UserHeader from '../dashboard/UserHeader';

const SubscriptionBilling = () => {
  return (
    <div className="setting toggle-sidebar">
      <UserHeader />
      <div id="main" className="main">
        <div className="group-breadcrumb">
          <div className="breadcrumb-left">
            <ul>
              <li>
                <a href="/dashboard">Dashboard</a>
              </li>
              <li>
                <strong>Subscription &amp; Billing</strong>
              </li>
            </ul>
            <h1>Subscription &amp; Billing</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBilling;
